import type { SitemapNode } from './AppLayout.js';

/**
 * 从 sitemap 中移除尚未发布的目标路由，并递归清理因此变空的分组。
 * 平台原生页面没有 customUrl 时不受影响。
 */
export function filterSitemapByAvailability(
  nodes: SitemapNode[],
  isPathAvailable: (path: string) => boolean,
): SitemapNode[] {
  return nodes.reduce<SitemapNode[]>((visible, node) => {
    if (node.customUrl && !isPathAvailable(node.customUrl)) return visible;

    const children = filterSitemapByAvailability(node.children, isPathAvailable);
    if (node.children.length > 0 && children.length === 0) return visible;

    visible.push(children === node.children ? node : { ...node, children });
    return visible;
  }, []);
}

function isRetiredPlatformNode(node: SitemapNode): boolean {
  const customUrl = (node.customUrl ?? '').toLowerCase();
  const displayNameZh = node.displayNameZh.trim();
  const displayNameEn = node.displayNameEn.trim().toLowerCase();
  return (
    customUrl.startsWith('/app/admin/document-library') ||
    customUrl.startsWith('/app/admin/settings?section=country-code') ||
    customUrl.startsWith('/app/admin/number-rules') ||
    displayNameZh === '文档库管理' ||
    displayNameEn === 'document library' ||
    displayNameZh === '基础数据' ||
    displayNameEn === 'master data' ||
    displayNameZh === '扩展规则' ||
    displayNameEn === 'extension rules'
  );
}

/** 清理已经从 CREST 门户下线、但旧数据库中可能仍存在的菜单节点。 */
export function filterRetiredPlatformNodes(nodes: SitemapNode[]): SitemapNode[] {
  return nodes.reduce<SitemapNode[]>((visible, node) => {
    if (isRetiredPlatformNode(node)) return visible;

    const children = filterRetiredPlatformNodes(node.children);
    if (node.children.length > 0 && children.length === 0) return visible;

    visible.push(children === node.children ? node : { ...node, children });
    return visible;
  }, []);
}
